import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inventory-tabs" }
const _hoisted_2 = { class: "scroll-container" }
const _hoisted_3 = { class: "scroll-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")!
  const _component_GenericTabs = _resolveComponent("GenericTabs")!
  const _component_InventoryItem = _resolveComponent("InventoryItem")!
  const _component_GenericPanel = _resolveComponent("GenericPanel")!

  return (_openBlock(), _createBlock(_component_GenericPanel, {
    "class-name": "char-stats-container",
    title: "INVENTORY"
  }, {
    "icons-right": _withCtx(() => [
      _createVNode(_component_GenericButton, {
        svg: "close",
        onClick: _ctx.closePanel
      }, null, 8, ["onClick"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_GenericTabs, {
          tabs: _ctx.tabs,
          variant: "contained",
          "max-width": "80%",
          onActiveTab: _ctx.handleActiveTab
        }, null, 8, ["tabs", "onActiveTab"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.inventory.head, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"margin-bottom":"5px"}
          }, [
            _createVNode(_component_InventoryItem, {
              item: item,
              "item-index": index
            }, null, 8, ["item", "item-index"])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.selectedTab === 'HELMETS']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.inventory.body, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            style: {"margin-bottom":"5px"}
          }, [
            _createVNode(_component_InventoryItem, {
              item: item,
              "item-index": index
            }, null, 8, ["item", "item-index"])
          ]))
        }), 128))
      ], 512), [
        [_vShow, _ctx.selectedTab === 'ARMORS']
      ])
    ]),
    _: 1
  }))
}